import { useMemo } from 'react';

import { GoogleFontLinks } from '@/components/shared/google-font-links';
import { getSpecificGoogleFontsUrl } from '@/lib/site-design/fonts';
import type { FontSettings } from '@/types/shared';

export function SiteFontLinks({ fonts }: { fonts?: FontSettings | null }) {
  const fontUrl = useMemo(() => {
    const fontNames = [fonts?.headings?.font, fonts?.paragraphs?.font].filter(
      (font): font is string => Boolean(font),
    );
    return getSpecificGoogleFontsUrl([...new Set(fontNames)]);
  }, [fonts]);

  return <GoogleFontLinks url={fontUrl} />;
}
